<template>
  <div class="block21">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1">火花塞</h2>

      <div class="container-content">
        <p class="text_line">检查火花塞</p>
        <p class="font-size1">
          有关建议的火花塞，请参见“
          <router-link to="/block48">技术参数</router-link>”。
        </p>
        <p>仅使用建议热值范围内的正确火花塞。</p>
        <div class="becareful">
          <h4>注意</h4>
          <p>使用热值范围错误的火花塞会损坏发动机。</p>
        </div>
        <ul class="numberspace">
          <li>
            <em>1</em>从火花塞上断开火花塞帽。
          </li>
          <li>
            <em>2</em>清理火花塞座周围的污垢。
          </li>
          <li>
            <em>3</em>使用随工具套件附带的火花塞套筒拆下火花塞。
          </li>
          <img src="./img/img1.jpg" width="100%" />
          <li>
            <em>4</em>检查电极和中心陶瓷体有无积垢、烧蚀或积碳。
            <ul class="triangle">
              <li>如果腐蚀或积碳严重，更换火花塞。</li>
              <li>用火花塞清洁剂清洗火花塞，或用钢丝刷。</li>
            </ul>
          </li>
          <li>
            <em>5</em>使用塞尺检查火花塞间隙。
            <ul class="triangle">
              <li>如果必须调整，小心弯曲侧电极。</li>
            </ul>
          </li>
           <table class="inside"><tr><td class="textLeft"><strong>火花塞间隙：</strong><br>0.80至0.90mm</td></tr></table>
          <img src="./img/img2.jpg" width="100%" />
          <li>
            <em>6</em>确保火花塞垫圈是良好的。
          </li>
          <li>
            <em>7</em>安装带有垫圈的新火花塞，用手拧入火花塞，以免错扣。
          </li>
          <li>
            <em>8</em>拧紧火花塞：
            <ul class="triangle">
              <li>
                如果旧的火花塞还可以使用：
                <br />拧紧后再拧1/8圈
              </li>
              <li>
                如果安装新的火花塞，请拧紧两次，
                以免其松动：
                <br />a)首先，拧紧火花塞，再拧1/2圈。
                <br />b)然后拧松火花塞
                <br />c)接下来，再次拧紧火花塞，再拧1/8圈。
                <br />
              </li>
            </ul>
            <div class="becareful">
              <h4>注意</h4>
              <p>
                火花塞拧紧不当可能会损坏发动机。如
                果火花塞过松，则可能活塞受损。
                <br />如果火花塞太紧，则可能螺纹受损。
              </p>
            </div>
          </li>
          <li>
            <em>9</em>重新安装火花塞帽。请小心操作，以免夹住电缆或电线。
          </li>
        </ul>
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block20">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block22">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>